<template>
  <div
    :class="{ jumbotron: true, clickable: !!onClick, selected: selected }"
    @click="$emit('click')"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
defineProps({
  onClick: Function,
  selected: Boolean,
});
</script>

<style scoped lang="postcss">
.jumbotron {
  @apply rounded-xl font-semibold;
}

.selected {
  @apply bg-background-secondary;
}

.clickable {
  @apply hover:opacity-25;
  @apply cursor-pointer;
}
</style>
